import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { Button } from '../elements';
import { landingImage } from '../assets';

// Text
const TITLE = 'Find a Career You Love';
const ABOUT = 'Future Gen is a career discovery platform aimed at young adults to help them build the confidence they need to pursue careers that suit them.';

const Landing: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  console.log('Landing component rendering', { isMobile, isTablet });

  return (
    <Container
      maxWidth={isMobile ? false : "lg"}
      disableGutters={isMobile}
      sx={{
        px: { xs: 2, sm: 3, md: 3 },
        py: { xs: 2, sm: 3, md: 4 },
        width: '100%'
      }}
    >
      <Box display="flex" flexDirection="column" justifyContent="center" sx={{
        marginTop: isMobile ? '20px' : '55px',
        padding: isMobile ? 2 : 4,
        minHeight: isMobile ? 'calc(100vh - 200px)' : 'auto'
      }}>
        <Grid container spacing={isMobile ? 3 : 4} alignItems="center">
          <Grid size={{xs: 12, md: 6}} sx={{order: isMobile ? 2 : 1}}>
            <Box component="img"
              src={landingImage}
              alt="Future Gen landing illustration"
              sx={{
                width: '100%',
                height: 'auto',
                maxWidth: isMobile ? '300px' : '500px',
                margin: '0 auto',
                display: 'block'
              }}
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}} sx={{order: isMobile ? 1 : 2}}>
            <Box display="flex" flexDirection="column" alignItems={isMobile ? "center" : "flex-start"} sx={{
              textAlign: isMobile ? 'center' : 'left',
              px: isMobile ? 1 : 2
            }}>
              <Typography gutterBottom component="h3" variant="h3" sx={{
                fontWeight: 900,
                fontSize: isMobile ? '1.75rem' : isTablet ? '2.5rem' : '3rem',
                lineHeight: 1.2,
                mb: 3
              }}>
                {TITLE}
              </Typography>
              <Typography gutterBottom component="h6" variant="h6" sx={{
                marginTop: isMobile ? 2 : 5,
                marginBottom: isMobile ? 3 : 5,
                fontSize: isMobile ? '1rem' : '1.25rem',
                maxWidth: '500px'
              }}>
                {ABOUT}
              </Typography>

              <Box display="flex" flexDirection={isMobile ? "column" : "row"} justifyContent="center" sx={{
                gap: 2,
                width: isMobile ? '100%' : 'auto'
              }}>
                <Button
                  format="secondary"
                  text="Login"
                  aria-label="Login to your account"
                  onClick={() => navigate('/login')}
                  style={{
                    width: isMobile ? '100%' : 200,
                    maxWidth: isMobile ? '300px' : '200px',
                    margin: isMobile ? 0 : 2
                  }}
                />
                <Button
                  format="primary"
                  text="Start Here"
                  aria-label="Start your career discovery"
                  onClick={() => navigate('/register')}
                  style={{
                    width: isMobile ? '100%' : 200,
                    maxWidth: isMobile ? '300px' : '200px',
                    margin: isMobile ? 0 : 2
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Landing; 